import { useState, useEffect } from 'react';

interface Location {
  lat: number;
  lng: number;
}

export const useReverseGeocode = (location: Location | null) => {
  const [locationAddress, setLocationAddress] = useState<string>('');

  useEffect(() => {
    const reverseGeocode = async () => {
      if (!location) return;

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${location.lat}&lon=${location.lng}`
        );
        const data = await response.json();
        if (data.display_name) {
          setLocationAddress(data.display_name);
        }
      } catch (error) {
        console.error('Failed to reverse geocode:', error);
        setLocationAddress('');
      }
    };

    reverseGeocode();
  }, [location]);

  return locationAddress;
};
